var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card',{attrs:{"name":"overview.transport_mode_overview","padded":""}},[_c('error-state',{attrs:{"type":"placeholder"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }